<template>
  <div class="container">
    <d-pageedit 
      v-model="g"
      canadd
      title="Catalog"
      :search="getsearch()"
      :params="params"
      :margintop="80"
      @clear="clear($event)"
      @load="load($event)"
      @del="del($event)"
      @save="save($event)"
    >
      <div v-if="validcod">
        <div class="row">
          <d-input v-model="g.des" type="text" label="Description" :cols="10" />
          <d-input v-model="g.defversion" type="text" label="Version" :cols="2" />
        </div>
        <div class="row">
          <d-auth v-model="g.owners" label="adminstrators" :cols="6" admins shops users groups brands modules countries />
          <d-auth v-model="g.users" label="users" :cols="6" admins shops users groups brands modules countries />
        </div>
        <div class="row">
          <d-date v-model="g.datafrom" label="valid from" :cols="3" />
          <d-date v-model="g.datato" label="valid to" :cols="3" />
          <d-input v-model="g.local" type="check" label="Local" :cols="1" />
          <template v-if="g.local">
            <d-input v-model="g.isvariant" type="check" label="variant" :cols="1" />
            <d-input v-model="g.isshop" type="check" label="shop" :cols="1" />
            <d-input v-model="g.topic" type="text" label="Topic" :cols="3" />
          </template>
          <template v-else>
            <d-coddes v-model="g.company" table="server2,,company" :follow="getfollow" :cols="5" label="company" />
          </template>
        </div>
        <div class="row mt-3">
          <div class="col">
            <d-card title="Extra Data" expand closed>  
              <d-table :rows="g.extra" :columns="extracols" editable add>
              </d-table>
            </d-card>
            <d-card title="Versions" expand closed>  
              <d-table :rows="g.vers" :columns="extravers" editable add @addelement="addvers($event)">
                <div slot="datafrom" slot-scope="s">
                  <d-date v-model="s.data.datafrom" noborder small />
                </div>
                <div slot="datato" slot-scope="s">
                  <d-date v-model="s.data.datato" noborder small />
                </div>
                <div slot="auth" slot-scope="s">
                  <d-auth v-model="s.data.auth" small noborder admins shops users groups brands modules countries />
                </div>
              </d-table>
            </d-card>
            <d-card title="File Locations" expand closed>  
              <d-table :rows="g.files" :columns="extrafiles" editable add>
                <div slot="location" slot-scope="s">
                  <d-input v-model="s.data.location" type="select" :options="locationoptions" small noborder />
                </div>
              </d-table>
            </d-card>
          </div>
        </div>
        
      </div>
        
    </d-pageedit>
  </div>
</template>

<script>
import { Dau, bus } from "@store/dau"
export default {
  props: {
    params: String
  },
  data() {
    return {
      g: {},
      extracols: [
        { id:'cod', title:'code', w:1 },
        { id:'des', title:'description', w:3 }
      ],
      extravers:[
        { id:'datafrom', title:'Data From', w:1 },
        { id:'datato', title:'Data To', w:1 },
        { id:'version', title:'version', w:1 },
        { id:'auth', title:'Auth', w:2 }
      ],
      extrafiles:[
        { id:'file', title:'File', w:1 },
        { id:'location', title:'Location', w:1 },
        { id:'des', title:'Description', w:2 }
      ],
      locationoptions: [
         { cod:'0', des:Dau.T('Catalog') },
         { cod:'1', des:Dau.T('Company') },
         { cod:'2', des:Dau.T('Organization') }
      ]
    };
  },
  computed: {
     validcod()  {
       return this.g.cod;
     },
     getfollow() {
        return this.g.company && this.g.company.cod?"admcompany."+this.g.company.cod:"";
     }
  },
  methods: {
    addvers(e) {  // add a new row on vers
      e.datafrom=0;
      e.datato=0;
      e.version="0";
      e.auth="G999"
    },
    clear(e) {
      this.g={
         cod:'', // add every variable
         extra:[],
         vers:[]
      }
    },
    load(e) {
      Dau.com("server2", "jGetCatalog", { cod: e.data.cat || "", dir: "" }, d => {
        this.g = d;
      });
    },
    save(e) {
      Dau.com("server2", "jSaveCatalog", { data:JSON.stringify(this.g) }, d => {
        this.g = d;
        e.callback({cat:this.g.cod});
      });
    },
    del(e) {
      Dau.com("server2", "DeleteCatalog", { cod: this.g.cod  }, d => {
         e.callback();
      })
    },
    getsearch() {
      return {
        service: "server2",
        func: "HelperSearch",
        params: {
          Table: "Catalog"
        }
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/erp/pages/adm/admincatalogs.vue